import { executeFileExplorerTool } from './fileExplorerExecutor';
import { executeNotepadTool } from './notepadExecutor';
import { executeMapleWordTool } from './mapleWordExecutor';

export type AssistantExecutionContext = {
  openApp: (appId: string, title: string, filePath?: string, content?: string) => void;
  ensureDir: (path: string) => Promise<void>;
  createFolder: (path: string) => Promise<boolean>;
  createFile: (path: string, content?: string) => Promise<boolean>;
  readFile: (path: string) => Promise<string | null>;
  writeFile: (path: string, content: string) => Promise<boolean>;
  pathExists: (path: string) => boolean;
  resolveDocumentsPath: () => Promise<string>;
};

export type AssistantExecutionResult = {
  message: string;
  shouldClose?: boolean;
};

export const MUTATING_TOOL_KEYS = new Set([
  'file-explorer.create_folder',
  'file-explorer.create_file',
  'notepad.save_note',
  'maple-word.create_document',
  'maple-word.insert_text',
]);

export const isMutatingTool = (toolKey: string) => MUTATING_TOOL_KEYS.has(toolKey);

export async function executeTool(
  toolKey: string,
  args: Record<string, unknown>,
  ctx: AssistantExecutionContext,
): Promise<AssistantExecutionResult> {
  const [appId, actionId] = toolKey.split('.');

  switch (appId) {
    case 'file-explorer':
      return executeFileExplorerTool(actionId, args, ctx);
    case 'notepad':
      return executeNotepadTool(actionId, args, ctx);
    case 'maple-word':
      return executeMapleWordTool(actionId, args, ctx);
    default:
      throw new Error(`No executor is registered for ${toolKey}.`);
  }
}
